import React from "react";
import { BlockRenderer } from "../ReportRenderer";

export default function GroupBlock({ block, data, template }: any) {
  return (
    <div className={block.className || ""}>
      {(block.blocks || []).map((b: any, i: number) => (
        <BlockRenderer key={i} block={b} data={data} template={template} />
      ))}
    </div>
  );
}
